var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click', $event)}}},[(_vm.label)?_c('div',{staticClass:"button__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }